






























































































import { Vue, Component } from 'vue-property-decorator';
import Container from './../Registration/Container.vue';
import RegistrationCard from './../Registration/Card.vue';
import CardHeader from './../Registration/Header.vue';
import { vxm } from '../../store.vuex';
import { OtpValidationToken } from '../../models/userdata/otptoken';
import { OtpRequestToken } from '../../models/userdata/otprequesttoken';
import { VerificationError } from '../../models/userdata/verificationerror';
import OTPLoginForm from './../Login/v2/OTPLoginForm.vue';
import { mutation } from 'vuex-class-component';

@Component({
  components: {
    Container,
    RegistrationCard,
    CardHeader,
    OTPLoginForm,
  },
})
export default class UpdatePhoneVerification extends Vue {
  private otpToken: OtpValidationToken = new OtpValidationToken();
  private otpRequestToken: OtpRequestToken = new OtpRequestToken();
  private numberErrors = {
    phone: '',
  };
  public phone: string = '';
  $wlToastr: any;
  private phoneNumber: string = '';
  private phoneNumberValid: boolean = false;
  private mobileNumber: string = '';
  private country: string = '';
  private errors = new VerificationError();
  private showVerification: boolean = true;
  private onPhoneNumberSave: boolean = false;
  private username: string = '';
  private isEmailPresent: boolean = false;
  private password: any = [];
  private errors1: string = '';
  private isMobileScreen: boolean = false;
  private canResendCode: boolean = true;
  private showCounter: boolean = true;
  private email: string = '';
  private companyCode: string = '';
  private validationType: string = 'text message.';
  private conifrmButtonName: string = 'Submit';
  private onBackName: string = 'Cancel';
  onFinishCountdown() {
    this.canResendCode = false;
    this.showCounter = false;
  }

  showCountTime() {
    this.canResendCode = true;
    this.showCounter = true;
  }

  get resendCodeSecondsToCount(): number {
    return vxm.utility.timeToResendOTPCode;
  }
  closeEdit() {
    this.$modal.hide('edit-phone');
  }
  updateVerificationOtpPhone(event) {
    this.phone = event.nationalNumber;
    this.phoneNumberValid = event.isValid;
    this.country = event.countryCallingCode;
  }

  get companyName() {
    return vxm.configs.getGlobalConfigValue('WL_CANDIDATE_PORTAL_APPLICATION_NAME');
  }
  @mutation
  setPassword(object) {
    this.password.splice(object.index, 1, object.value);
  }
  isNumber(evt) {
    evt = evt ? evt : window.event;
    const charCode = evt.which ? evt.which : evt.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      evt.preventDefault();
    }
    return true;
  }

  submitChangePhone() {
    if (this.phone.length !== 10 || isNaN(Number(this.phone))) {
      this.numberErrors.phone = 'signup.phone.valid';
      return;
    }
    let number = '+' + this.country + ' ' + this.phone;
    if (number === vxm.users.myUserProfile.phoneNum) {
      this.$wlToastr(
        'error',
        this.$t('signup.phone.duplicate'),
        this.$t('UserProfile_MyProfile').toString(),
      );
      return;
    }
    this.otpRequestToken.newPhone = number;
    this.otpRequestToken.email = vxm.users.myUserProfile.email;
    this.otpRequestToken.companyCode = vxm.jobs.BrandingInfo.companycode;
    vxm.users
      .updatePhoneNumberTriggerSMSOTP(this.otpRequestToken)
      .then((resp) => {
        if (resp.meta.success === true) {
          this.onPhoneNumberSave = true;
          this.phoneNumber = this.otpRequestToken.newPhone;
          this.$wlToastr(
            'info',
            this.$t('new-verification-code-sent'),
            this.$t('changenumber.toast.title'),
          );
        } else {
          this.$wlToastr(
            'error',
            this.$t('ph-number-change-err-msg') + '.\n' + resp.meta.displayMessage,
            this.$t('changenumber.toast.title'),
          );
        }
      });
  }

  resendEventHandler() {
    if (this.phone.length !== 10 || isNaN(Number(this.phone))) {
      this.numberErrors.phone = 'signup.phone.valid';
      return;
    }
    let number = '+' + this.country + ' ' + this.phone;
    this.otpRequestToken.newPhone = number;
    this.otpRequestToken.email = vxm.users.myUserProfile.email;
    this.otpRequestToken.companyCode = vxm.jobs.BrandingInfo.companycode;
    vxm.users
      .updatePhoneNumberTriggerSMSOTP(this.otpRequestToken)
      .then((value) => {
        if (value.meta.success === true) {
          this.$wlToastr(
            'info',
            this.$t('resent-otp-success-msg'),
            this.$t('verification.toast.title'),
          );
        } else {
          const errorMessage = value.meta.displayMessage;
          this.$wlToastr(
            'error',
            errorMessage,
            this.$t('verification.toast.title'),
          );
        }
      });
  }
  validateOtp() {
    this.errors.otpToken = '';
    if (!this.otpToken.otp || this.otpToken.otp.length < 5) {
      this.errors.otpToken = this.$t('verification.otp.validation.message');
      return false;
    } else {
      return true;
    }
  }

  continueOTP() {
    this.errors1 = '';
    this.otpToken.otp = this.password.join('');
    if (!this.validateOtp()) {
      return;
    }
    const vm = this;
    this.otpToken.userIdStr = vxm.users.myUserProfile.email;
    this.otpToken.failureCount = '0';
    this.otpToken.failedAttemptCount = 0;
    this.otpToken.companyCode = vxm.jobs.BrandingInfo.companycode;
    vxm.users.ValidateUpdatePhoneNumberSMSOTP(vm.otpToken).then((value) => {
      if (value.data.meta.success === true) {
        vxm.users.getUserProfile();
        vm.$wlToastr('success', vm.$t('updatephoneverification.success'));
        this.$modal.hide('edit-phone');
        this.$router.push({ path: `/home` });
      } else {
        vm.$wlToastr(
          'error',
          vm.$t('ph-number-change-err-msg') + '.\n' + value.data.meta.displayMessage,
          vm.$t('changenumber.toast.title'),
        );
        this.errors1 = 'otp-login.invalidcode';
        //   vm.errors.otpToken = value.error;
      }
    });
  }

  get supportedCountries() {
    return vxm.utility.supportedCountries;
  }

  get defaultCountry() {
    return vxm.utility.defaultCountry;
  }
}
